"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Dialog = require("../../../shared/Dialog/DialogActions");
const react_redux_1 = require("react-redux");
const api_1 = require("../../../api");
const utils_1 = require("../../../utils");
const AuthenticationActions_1 = require("../../../authentication/AuthenticationActions");
const HomeLanding_1 = require("../../home/components/HomeLanding");
const mapDispatchToProps = dispatch => {
    return {
        loginSuccess: data => dispatch(AuthenticationActions_1.loginSuccess(data))
    };
};
class Confirmation extends React.Component {
    render() {
        return React.createElement(HomeLanding_1.default, null);
    }
    componentDidMount() {
        let code = this.props.params.code;
        api_1.doGet(utils_1.RouteUtils.set(api_1.API.v1.CONFIRMATION, { code: code })).then(response => {
            this.showSuccessDialog({
                user: response.data.user,
                accessToken: response.data.access_token,
                organization: response.data.user.organization
            });
        }).catch(error => {
            this.showFaildDialog();
        });
    }
    showSuccessDialog(data) {
        Dialog.showAlertDialog({
            title: "Activated",
            message: "Your account successfully activated",
            onClose: () => {
                this.props.loginSuccess(data);
                window.location.replace(`/${data.organization.routePrefix}/app`);
            }
        });
    }
    showFaildDialog() {
        Dialog.showAlertDialog({
            title: "Activation failed",
            message: "Looks like Your activation code is not right."
        });
    }
}
exports.default = react_redux_1.connect(null, mapDispatchToProps)(Confirmation);


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/confirmation/components/confirmation.tsx
// module id = 1104
// module chunks = 0 1